import tw from "twin.macro";

export const LogoBackground = tw.div`bg-white p-2 rounded-md`;
export const LogoImg = tw.img`w-10`;
export const LogoText = tw.h5`ml-1 text-2xl font-black tracking-wider`;
